<template>
 <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>

  <a-card class="all-card-style">
    <img src="../../img/leftclock.png" class="leftclock">
     <div id="container"></div>
     
     
  </a-card>
 <a-card class="all-card-style " style=" margin-top: -135px;">
      <!--筛选条件-->
      <div class="search-box">
        <a-form layout="inline" :form="form" @submit="">

          <a-form-item
            label="展现形式"
          >
            <a-button-group>
              <a-button @click="showLine">曲线</a-button>
              <a-button @click="showTable">表格</a-button>
            </a-button-group>
          </a-form-item>

          <a-form-item
            label="起止日期"
          >
            <a-range-picker
              :default-value="[deviceData.queryInfoList.startDate, deviceData.queryInfoList.endDate]"
              @change="dateSelect"
            />
          </a-form-item>

          <a-form-item>
            <a-select :value="proSelectItem.value" style="width: 120px" @change="proSelect">
              <!-- <a-select-option value="1">
                全部
              </a-select-option>
              <a-select-option value="2">
                溶解氧
              </a-select-option>
              <a-select-option value="3">
                PH值
              </a-select-option>
              <a-select-option value="4">
                水温
              </a-select-option>
              <a-select-option value="5">
                压力
              </a-select-option> -->
              <a-select-option v-for="(item,index) in proSelectItems" :key="item.key" :value="index">
                {{item.value}}
              </a-select-option>

            </a-select>
          </a-form-item>

          <a-form-item>
            <a-select v-model="deviceData.queryInfoList.timeType"  style="width: 120px" >
              <a-select-option v-for="(item,index) in timeTypeSel"  :key="index" :value="item.ID" >
                {{item.name}}
              </a-select-option>

            </a-select>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" html-type="button" @click="search">
              查询
            </a-button>
            <span class="button-margin"></span>
            <a-button html-type="submit" >
              导出
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <!--曲线-->
      <div  v-show="lineVisible">
        <div>
          <img src="../../contralimg/conzuo.png" class="vurve-box">
        </div>
      </div>

      <!--    表格-->
      <div v-if="tableVisible">
        <a-table :columns="columns" :data-source="data2"></a-table>
      </div>
    </a-card>

 </div>
</template>
<script>
  import TitleCard from '@/components/TitleCard.vue'
import { Chart, registerShape } from '@antv/g2';
    const columns = [

    {
      title: '时间',
      dataIndex: 'time',
      key: 'time',
    },
    {
      title: '原始值',
      dataIndex: 'value',
      key: 'value',
    },
  ];

  const data = [
    {
      key: '1',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },
    {
      key: '2',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },
    {
      key: '3',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },

    {
      key: '4',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },

    {
      key: '5',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },
  ];

  const data2 = [
    { time: '1991', value: '3' },
    { time: '1992', value: '4' },
    { time: '1993', value: '3.5' },
    { time: '1994', value: '6' },
    { time: '1995', value: '4.9' },
    { time: '1996', value: '6' },
    { time: '1997', value: '7' },
    { time: '1998', value: '9' },
    { time: '1999', value: '13' },
  ];

  export default {
     components: {
      TitleCard
    },

    data(){
      return{
         titleMsg1: "能耗分析",
        titleMsg2:'能耗分析',
        titleMsg3:'能耗分析详情',

          form: this.$form.createForm(this),
        lineVisible:true,
        tableVisible:false,
        columns,
        data,
        data2,
        chart: {},
        IotId:'',
        proSelectItems:[],
        proSelectItem:{
          key:"",
          value:""
        },
       timeTypeSel:[
          {ID:1,name:'实时曲线'},
         {ID:2,name:'早均线'},
         {ID:3,name:'晚均线'},
         {ID:4,name:'日均线'}
          ],
        deviceData:{
          queryInfo:{
            productkey:"",
            devicename:"",
            limit:1
          },
          queryInfoList:{
            productkey:"",
            devicename:"",
            identifier:"",
            startDate:'1900-01-01',
            endDate:'1900-01-01',
            page:0,
            limit:0,
            timeType:1
          },
          devices:{},
          proDataTime:"",
          propertiesR:[],
          dataList:[],
          timer: '',//定时器
          timerList:''
        },
      

      }
    },
    methods:{
       showLine:function(){
        this.lineVisible=true;
        this.tableVisible=false;
        // this.reloadDrawing()

      },
      showTable:function () {
        // this.reloadDrawing();

        this.lineVisible=false;
        this.tableVisible=true;

      },
   

    },
    mounted() {
         registerShape('point', 'pointer', {
  draw(cfg, container) {
    const group = container.addGroup();
    const center = this.parsePoint({ x: 0, y: 0 }); // 获取极坐标系下画布中心点
    // 绘制指针
    group.addShape('line', {
      attrs: {
        x1: center.x,
        y1: center.y,
        x2: cfg.x,
        y2: cfg.y,
        stroke: cfg.color,
        lineWidth: 5,
        lineCap: 'round',
      },
    });
    group.addShape('circle', {
      attrs: {
        x: center.x,
        y: center.y,
        r: 9.75,
        stroke: cfg.color,
        lineWidth: 4.5,
        fill: '#333333',
      },
    });

    return group;
  },
});

const data = [{ value: 5.6 }];
const chart = new Chart({
  container: 'container',
  autoFit: true,
  height: 350,
  padding: [0, 0, 30, 0],

});

chart.data(data);
chart.scale('value', {
  min: 0,
  max: 160,
  tickInterval: 20,
});
chart.coordinate('polar', {
  startAngle: (-9 / 8) * Math.PI,
  endAngle: (1 / 8) * Math.PI,
  radius: 0.49,

});

chart.axis('1', false);
chart.axis('value', {
  line: null,
  label: {
    offset: -36,
    style: {
      fontSize: 18,
      textAlign: 'center',
      textBaseline: 'middle',

    },
  },
  subTickLine: {
    count: 4,
    length: -15,
     stroke: '#333333',
  },
  tickLine: {
    length: -24,
    
  },
  grid: null,
});
chart.legend(false);
chart
  .point()
  .position('value*1')
  .shape('pointer')
  .color('#7A7A7A')
  .animate({
    appear: {
      animation: 'fade-in'
    }
  });

// 绘制仪表盘背景
// chart.annotation().arc({
//   top: false,
//   start: [0, 1],
//   end: [9, 1],
//   style: {
//     // 底灰色
//     stroke: '#333333',
//     lineWidth: 18,

//     lineDash: null,
//   },
// });

// 绘制指标
// chart.annotation().arc({
//   start: [0, 1],
//   end: [data[0].value, 1],
//   style: {
//     stroke: '#333333',
//     lineWidth: 18,
//     lineDash: null,
//   },
// });
// 绘制指标数字
chart.annotation().text({
  position: ['50%', '55%'],
  content: '电表',
  style: {
    fontSize: 20,
    fill:false,
    textAlign: 'center',
   
    stroke: '#00E9F9',
  },
});
chart.annotation().text({
  position: ['50%', '62%'],
  content: '总用电量/KWH',
  style: {
    fontSize: 10,
    fill:false,
    textAlign: 'center',
    fontWeight:10,
    stroke: '#00E9F9',
  },
});
chart.annotation().text({
  position: ['49.5%', '92%'],
  stroke:'#333333',
     height:20,
    width:50,
  content: `${data[0].value * 10} `,
  style: {
 
    fontSize: 20,
    fill: false,
    textAlign: 'center',
  },
  offsetY: 15,
});

chart.render();

    }
    
  }

</script>
<style>
.leftclock{
  position: absolute;
  top: 20%;
  left: 40%;
  height: 300px;
  width: 300px;
}
</style>